import { Box } from '@chakra-ui/react';
import type { CSSProperties } from 'react';

interface PriceDisplayProps {
  price: number;
  change?: number;
  changePercent?: number;
  size?: 'sm' | 'md' | 'lg';
  showChange?: boolean;
  style?: CSSProperties;
}

const sizes = {
  sm: { fontSize: '14px', lineHeight: '20px' },
  md: { fontSize: '16px', lineHeight: '24px' },
  lg: { fontSize: '20px', lineHeight: '30px' },
};

export function PriceDisplay({
  price,
  change,
  changePercent,
  size = 'md',
  showChange = true,
  style,
}: PriceDisplayProps) {
  const isPositive = (change ?? 0) >= 0;
  const s = sizes[size];

  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="baseline"
      gap="2"
      fontFamily="mono"
      css={{ fontVariantNumeric: 'tabular-nums' }}
      fontSize={s.fontSize}
      lineHeight={s.lineHeight}
      style={style}
    >
      <Box
        as="span"
        color="text.primary"
        fontWeight="500"
        minW={size === 'lg' ? '120px' : '80px'}
        textAlign="right"
      >
        {formatPrice(price)}
      </Box>
      {showChange && change !== undefined && changePercent !== undefined && (
        <Box
          as="span"
          color={isPositive ? 'status.success.text' : 'status.error.text'}
          fontSize={size === 'lg' ? '14px' : '12px'}
          fontWeight="500"
          minW="72px"
        >
          {isPositive ? '+' : ''}{change.toFixed(2)} ({isPositive ? '+' : ''}{changePercent.toFixed(2)}%)
        </Box>
      )}
    </Box>
  );
}

function formatPrice(price: number): string {
  if (price === 0) return '--';
  if (price >= 1000) return price.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (price >= 1) return price.toFixed(2);
  return price.toFixed(4);
}
